import { render, staticRenderFns } from "./showV2.vue?vue&type=template&id=9cea9ec2&"
import script from "./showV2.vue?vue&type=script&lang=js&"
export * from "./showV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports